import React from "react";
import { MapPin, Home, Hash, Mail, MapPinned, Flag } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

export default function DaneAdresoweSection({ address = {} }) {
  const addr = address || {};
  return (
    <Sekcja
      title="Dane adresowe"
      icon={MapPin}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      <div className="sectionGrid">
        <div>
          <RowIcon icon={Home} label="Ulica">{addr.street || <em>—</em>}</RowIcon>
          <RowIcon icon={Hash} label="Nr domu">{addr.number || <em>—</em>}</RowIcon>
          <RowIcon icon={Hash} label="Nr mieszkania">{addr.local || <em>—</em>}</RowIcon>
          <RowIcon icon={Mail} label="Kod pocztowy">{mono(addr.postcode)}</RowIcon>
          <RowIcon icon={Mail} label="Poczta">{addr.post || <em>—</em>}</RowIcon>
        </div>
        <div>
          <RowIcon icon={MapPin} label="Miejscowość">{addr.city || <em>—</em>}</RowIcon>
          <RowIcon icon={MapPinned} label="Powiat">{addr.county || <em>—</em>}</RowIcon>
          <RowIcon icon={MapPinned} label="Województwo">{addr.region || <em>—</em>}</RowIcon>
          <RowIcon icon={Flag} label="Kraj">{addr.country || <em>—</em>}</RowIcon>
        </div>
      </div>
    </Sekcja>
  );
}
